import React, { useEffect } from 'react';
import { useAppSelector, useRoutes, useUserAction } from 'hooks';
import { Route } from 'routes';
import { matchPath, RouteProps, useHistory, useRouteMatch } from 'react-router-dom';
import { LayoutDashboard, LoggedUser, SidebarLink } from 'layouts';
import { authService } from 'services';
import { selectorOrders } from 'features/badges/badgesSlice';
import { Badge } from 'components';
import { useTranslation } from 'react-i18next';

type Props = {
  routes: Route[];
};

function Editor({ routes }: Props): JSX.Element {
  const { t } = useTranslation(['badge']);
  const { path } = useRouteMatch();
  const [renderRoutes] = useRoutes(routes, path);
  const history = useHistory();
  const hasOrdersBadge = !!useAppSelector(selectorOrders).length;
  useUserAction();

  useEffect(() => {
    document.body.classList.add('pt-80', 'xl:pt-0');

    return () => {
      document.body.classList.remove('pt-80', 'xl:pt-0');
    };
  }, []);

  const isActive = (value: RouteProps) => {
    const match = matchPath(history.location.pathname, value);

    return !!match;
  };

  const renderControls = () => (
    <>
      <LoggedUser />
      <ul className="mt-40 xl:mt-64">
        <li className="mb-24">
          <SidebarLink
            as="route"
            to="/redaktor"
            icon="dashboard"
            active={isActive({
              path: '/redaktor',
              exact: true,
            })}
          >
            Dashboard
          </SidebarLink>
        </li>
        <li className="mb-24">
          <div className="flex justify-between items-center w-full">
            <SidebarLink
              as="route"
              to="/redaktor/moje-zlecenia"
              icon="files"
              active={isActive({
                path: '/redaktor/moje-zlecenia',
              })}
            >
              Moje zlecenia
            </SidebarLink>
            {hasOrdersBadge && <Badge title={t('badge:new')} />}
          </div>
        </li>
        <li className="mb-24">
          <SidebarLink
            as="route"
            to="/redaktor/rozliczenia"
            icon="payments"
            active={isActive({
              path: '/redaktor/rozliczenia',
            })}
          >
            Rozliczenia
          </SidebarLink>
        </li>
        <li className="mb-24">
          <SidebarLink
            as="route"
            to="/redaktor/moje-dane"
            icon="user"
            active={isActive({
              path: '/redaktor/moje-dane',
            })}
          >
            Moje dane
          </SidebarLink>
        </li>
        <li className="mb-24">
          <SidebarLink as="button" to="" icon="logout" onClick={() => authService.logout()}>
            Wyloguj się
          </SidebarLink>
        </li>
      </ul>
    </>
  );

  return <LayoutDashboard renderControls={renderControls()}>{renderRoutes()}</LayoutDashboard>;
}

export default Editor;
